import { createAsyncThunk } from "@reduxjs/toolkit";
import { type KycCapture } from "../../../domain/entities/kyc-capture";
import { type KycDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const listCaptures = createAsyncThunk<
  KycCapture[],
  string,
  { dispatch: KycDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LIST_CAPTURES, async (requestId, { extra }) => {
  return await extra.kycRepo.listCaptures(requestId);
});
